// CONFIGURATION
  // ---- Worker addresses -------------------------------------------------
  // Live is what every customer uses. Add ?bwenv=staging to the page address to point
  // YOUR browser at the staging Worker (remembered until you use ?bwenv=live).
  // Nothing about this is visible to customers.
  const WORKERS = {
    live:    "https://battery-rego-proxy.geelong-ee4.workers.dev/",
    staging: "https://battery-rego-proxy-staging.geelong-ee4.workers.dev/"
  };
  const BW_ENV = (() => {
    try {
      const asked = new URLSearchParams(window.location.search).get("bwenv");
      if (asked) localStorage.setItem("bwEnv", asked);
      return localStorage.getItem("bwEnv") === "staging" ? "staging" : "live";
    } catch (e) { return "live"; }
  })();
  const CLOUDFLARE_WORKER_URL = WORKERS[BW_ENV];
  if (BW_ENV !== "live") console.info("Battery finder: using the STAGING Worker");

  const DATA_PATH = "v3-data-8kz2";                       // must match DATA_PATH in the Worker (or its default)
  const YMM_DATA_URL = CLOUDFLARE_WORKER_URL + DATA_PATH;
  const PRODUCTS_URL = CLOUDFLARE_WORKER_URL + "products"; // live fitment code -> product handles
  const CONTACT_URL = "/pages/contact";                   // "Contact us" button on the results help banner

  // Products are read straight from the theme: /collections/all/fitment-n70zz?view=fitment
  // (needs templates/collection.fitment.liquid and fitment:CODE tags on the products).
  // No API token, nothing to expire. Set to false to go back through the Worker instead.
  // Brand order for the "Recommended" sort. Matched against the product's Vendor, and
  // against the title as a fallback (some Hankooks are listed under the Battery Empire vendor).
  // Shops shown on each battery, in this order.
  //   match – any part of the location name in Shopify (Settings -> Locations), case doesn't matter
  //   label – the short name shown on the card; hovering shows Shopify's full name
  // A location that isn't listed here still shows, after these, under its own name.
  //   useOverall – tick this row whenever the battery is buyable at all. Use it for the
  //                 warehouse, which has no click & collect so Shopify never lists it.
  const STOCK_LOCATIONS = [
    { match: "Melton",    label: "Melton" },
    { match: "Geelong",   label: "Geelong" },
    { match: "Warehouse", label: "Online warehouse", useOverall: true },
  ];

  const BRAND_ORDER = ["Deltec", "Varta", "Hankook", "Neuton Power", "Delkor", "Supercharge",
                       "Bosch", "Exide", "Century", "Energizer", "AC Delco", "Optima"];

  const USE_THEME_FEED = true;
  const TAG_PREFIX = "fitment:";   // the tag you put on products, e.g. fitment:N70ZZ. "" if the tag is just the code.
  // sort_by=best-selling lets us record how popular each battery is, for the "Most bought" sort
  const FEED_URL = code => `/collections/all/${shopifyHandle(TAG_PREFIX + code)}?view=fitment&sort_by=best-selling`;

  // Plate colours per state. accent = badge + border, text = plate lettering.
  // Plate colours per state: bg = plate background, text = lettering, accent = border/divider
  const PLATE_THEMES = {
    ACT:   { bg: "#ffffff", text: "#203CA8", accent: "#203CA8", name: "Australian Capital Territory" },
    NSW:   { bg: "#E0D50C", text: "#111111", accent: "#111111", name: "New South Wales" },
    NT:    { bg: "#ffffff", text: "#C62D31", accent: "#C62D31", name: "Northern Territory" },
    QLD:   { bg: "#ffffff", text: "#8A223B", accent: "#8A223B", name: "Queensland" },
    SA:    { bg: "#ffffff", text: "#111111", accent: "#111111", name: "South Australia" },
    TAS:   { bg: "#ffffff", text: "#2F66BA", accent: "#2F66BA", name: "Tasmania" },
    VIC:   { bg: "#ffffff", text: "#162662", accent: "#162662", name: "Victoria" },
    WA:    { bg: "#ffffff", text: "#1E2AB5", accent: "#1E2AB5", name: "Western Australia" },
    HEAVY: { bg: "#ffffff", text: "#111111", accent: "#111111", name: "National Heavy Vehicle", placeholder: "E.G. FB·23CA" }
  };



  // NEVDIS make names -> make names used in the YMM data
  // What the rego database calls a make  ->  what OUR guide calls it.
  // The guide's own names are the values; anything not listed here falls through
  // to the tolerant matching in resolveMakes() below.
  const MAKE_ALIASES = {
    "MERCEDES-BENZ": ["Mercedes"], "MERCEDES BENZ": ["Mercedes"],
    "MERCEDES-AMG": ["Mercedes"], "MERCEDES AMG": ["Mercedes"], "AMG": ["Mercedes"],
    "LAND ROVER": ["Landrover", "Range Rover"], "LANDROVER": ["Landrover", "Range Rover"],
    "RANGE ROVER": ["Range Rover", "Landrover"],
    "HSV": ["Holden Special Vehicles"], "HOLDEN SPECIAL VEHICLES": ["Holden Special Vehicles"],
    "FPV": ["Ford Performance Vehicles"], "FORD PERFORMANCE VEHICLES": ["Ford Performance Vehicles"],
    // GWM sells Great Wall, Haval, Tank, Cannon and Ora under the one badge
    "GWM": ["Great Wall", "Haval"],
    "GWM HAVAL": ["Haval", "Great Wall"], "GWM ORA": ["Haval", "Great Wall"],
    "GREAT WALL MOTORS": ["Great Wall"], "GREAT WALL MOTOR": ["Great Wall"],
    "TANK": ["Great Wall"], "ORA": ["Haval", "Great Wall"],
    "ROLLS-ROYCE": ["Rolls Royce"],
    "CHEVROLET": ["Chevrolet", "Chev / GMC"], "GMC": ["Chev / GMC"], "CHEV": ["Chev / GMC", "Chevrolet"],
    "ISUZU UTE": ["Isuzu"], "ISUZU UTE AUSTRALIA": ["Isuzu"],
    "KGM": ["Ssangyong"], "KG MOBILITY": ["Ssangyong"], "SSANG YONG": ["Ssangyong"],
    "LDV": ["LDV"], "MAXUS": ["LDV"], "SAIC": ["LDV"], "SAIC MAXUS": ["LDV"],
    "VW": ["Volkswagen"], "VOLKSWAGEN COMMERCIAL": ["Volkswagen"], "VOLKSWAGEN COMMERCIAL VEHICLES": ["Volkswagen"],
    "SKODA": ["Skoda"], "ŠKODA": ["Skoda"],
    "CITROEN": ["Citroen"], "CITROËN": ["Citroen"],
    "ALFA": ["Alfa Romeo"],
    "OMODA": ["Chery"], "JAECOO": ["Chery"], "OMODA JAECOO": ["Chery"],
    "MG ROVER": ["MG", "Rover"], "MG MOTOR": ["MG"],
    // Badges our guide files as a model under the parent make
    "RAM": ["Dodge"], "RAM TRUCKS": ["Dodge"], "DODGE RAM": ["Dodge"],
    "INFINITI": ["Infiniti", "Nissan"],            // older Infinitis sit under Nissan
    "GENESIS": ["Genesis", "Hyundai"],             // the 2014-17 Genesis is a Hyundai here
    "MINI": ["Mini", "Leyland"],                   // the classic Mini is under Leyland
    "ALPINA": ["BMW"], "BMW ALPINA": ["BMW"],
    "BMW MINI": ["Mini"], "MINI COOPER": ["Mini"],
    "FIAT PROFESSIONAL": ["Fiat"],
    "JAGUAR DAIMLER": ["Jaguar", "Daimler"],
    "GENESIS MOTORS": ["Genesis", "Hyundai"]
  };

  // Suffixes the rego database bolts onto a make that our guide never uses
  const MAKE_NOISE = /\b(MOTOR|MOTORS|AUTOMOBILE|AUTOMOBILES|AUSTRALIA|AUSTRALIAN|AUST|GROUP|HOLDINGS?|UTE|COMMERCIAL|VEHICLE|VEHICLES|CARS?|PROFESSIONAL|CO|LTD|PTY|INC)\b/g;

  const VEHICLE_TYPE = "Car";          // cars only for now
  let makesList = [];                  // makes are loaded first; each make's vehicles are fetched when picked
  let portalAliases = {};              // "treat this make as…" rules, managed in the portal
  let pendingNotes = [];               // warnings carried over when several variants share one battery
  let pendingLabel = "";               // the customer's own car, for the results heading
  let pendingFitNote = "";             // "the same battery fits all of these"

  /**
   * When several variants share one battery we show it without asking. Say so plainly,
   * naming the variants, so nobody thinks we guessed their engine. Where the names share
   * a common start ("F-Pace Diesel & Petrol 2.0 / 3.0 / 5.0") only the differences are
   * listed, because that's the bit a customer recognises.
   */
  function sameBatteryNote(matches) {
    const names = [...new Set(matches.map(m => m.model).filter(Boolean))];
    if (names.length < 2) return "";
    const split = n => n.trim().split(/\s+/);
    const first = split(names[0]);
    let common = 0;
    while (common < first.length - 1 &&
           names.every(n => { const w = split(n); return w.length > common + 1 && w[common].toLowerCase() === first[common].toLowerCase(); })) common++;
    const tails = names.map(n => split(n).slice(common).join(" ")).filter(Boolean);
    const list = arr => arr.length > 1 ? arr.slice(0, -1).join(", ") + " and " + arr[arr.length - 1] : arr[0];
    const shared = first.slice(0, common).join(" ");
    const useTails = common > 0 && tails.length === names.length && new Set(tails).size === names.length
                     && tails.every(t => t.length <= 24);
    return useTails
      ? `The same battery fits every ${shared} we list – ${list(tails)} – so there's nothing to choose between.`
      : `The same battery fits all of these: ${list(names)}.`;
  }
  let rowsByMake = {};                 // { "Toyota": [{ make, model, series, year, notes, fitmentCode }] }
  let dataReady = false;
  let regoOff = false, regoOffMessage = "";
  let selectedValues = { make: "", model: "", year: "" };
  let optionsData = { make: [], model: [], year: [] };
  let highlightedIndices = { make: -1, model: -1, year: -1 };

  function bwInit() {
    loadVehicleData();
    try { const s = localStorage.getItem("bwSort"); if (s) sortMode = s; } catch (e) {}
    if (getAccessCode()) showCodeLink();
    renderGarage();                            // saved vehicles from previous visits
    showResultsFromUrl();                      // shared links / back button restore the results
    const stateSel = document.getElementById("bw-rego-state");
    applyPlateTheme(stateSel ? stateSel.value : "VIC");
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".bw-dd-wrapper")) closeAllDropdowns();
    });
  }

  // The script may load after the page is ready (theme asset), so cover both cases
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bwInit);
  else bwInit();

  /* ---------- access code (staff / trade – skips the daily limits) ---------- */
  function getAccessCode() {
    try {
      const fromUrl = new URLSearchParams(window.location.search).get("code");
      if (fromUrl) localStorage.setItem("bwAccessCode", fromUrl.trim());
      return (localStorage.getItem("bwAccessCode") || "").trim();
    } catch (e) { return ""; }
  }

  function setAccessCode(value) {
    try { value ? localStorage.setItem("bwAccessCode", value.trim()) : localStorage.removeItem("bwAccessCode"); } catch (e) {}
  }

  function withCode(url) {
    const code = getAccessCode();
    return code ? url + (url.includes("?") ? "&" : "?") + "code=" + encodeURIComponent(code) : url;
  }

  // The trade code link only appears once someone hits the daily limit (or already has a code saved)
  function showCodeLink() {
    const link = document.getElementById("bw-code-link");
    if (link) link.style.display = "inline-block";
  }

  function toggleCodeBox() {
    const box = document.getElementById("bw-code-box");
    const open = box.style.display !== "none";
    box.style.display = open ? "none" : "flex";
    if (!open) { const i = document.getElementById("bw-code-input"); i.value = getAccessCode(); i.focus(); }
  }

  function saveAccessCode() {
    const value = document.getElementById("bw-code-input").value.trim();
    setAccessCode(value);
    document.getElementById("bw-code-box").style.display = "none";
    showWidgetMessage(value ? "Code saved on this device." : "Code removed.", "info");
  }

  /* ---------- helpers ---------- */
  const normKey = s => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  // Same rule Shopify uses to turn a tag into a URL: "Q85 EFB" -> "q85-efb"
  const shopifyHandle = s => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  // "CX-7 Petrol 2.3i" -> ["cx","7","petrol","2.3i"] ; "Mazda 3" -> ["mazda","3"]
  const words = s => String(s || "").toLowerCase().match(/[a-z]+|\d+(?:\.\d+)?[a-z]*/g) || [];
  const escHtml = s => String(s || "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  // For a value going inside a single-quoted onclick="...('here')"
  const escAttr = s => escHtml(s).replace(/&#39;/g, "\\&#39;");

  // "2005-2012", "08/2008-on", "1997-07/2002", "2016-on" -> month numbers
  function parseYearRange(str) {
    const s = String(str || "").trim().toLowerCase();
    const m = s.match(/^(?:(\d{1,2})\/)?(\d{4})\s*-\s*(?:(on)|(?:(\d{1,2})\/)?(\d{4}))$/);
    if (!m) {
      const y = s.match(/^(\d{4})$/);
      return y ? { from: +y[1] * 12, to: +y[1] * 12 + 11 } : null;
    }
    const from = (+m[2]) * 12 + (m[1] ? +m[1] - 1 : 0);
    const to = m[3] ? 9999 * 12 : (+m[5]) * 12 + (m[4] ? +m[4] - 1 : 11);
    return { from, to };
  }

  // strict: use the build month when we have it. loose: anywhere in the year.
  function yearMatches(rangeStr, year, compliance, strict) {
    if (!year) return true;
    const r = parseYearRange(rangeStr);
    if (!r) return false;
    const c = String(compliance || "").match(/^(\d{4})-(\d{1,2})/);
    if (strict && c) {
      const t = (+c[1]) * 12 + (+c[2] - 1);
      return t >= r.from && t <= r.to;
    }
    const y = +year;
    return y * 12 + 11 >= r.from && y * 12 <= r.to;
  }

  // Newest ranges first
  function sortYears(years) {
    return years.sort((a, b) => ((parseYearRange(b) || { from: 0 }).from) - ((parseYearRange(a) || { from: 0 }).from));
  }

  /* ---------- plate styling ---------- */
  function applyPlateTheme(key) {
    const plate = document.getElementById("bw-plate");
    if (!plate) return;
    if (plate.classList.contains("bw-plate-nostate")) key = "HEAVY";
    const theme = PLATE_THEMES[key] || PLATE_THEMES.VIC;
    plate.style.setProperty("--plate-accent", theme.accent || theme.text);
    plate.style.setProperty("--plate-text", theme.text);
    plate.style.setProperty("--plate-bg", theme.bg || "#ffffff");
    // Plates with a white background get a filled state block; coloured plates (NSW) keep the plate colour
    const plainPlate = (theme.bg || "#ffffff").toLowerCase() === "#ffffff";
    plate.style.setProperty("--plate-badge-bg", plainPlate ? (theme.accent || theme.text) : "transparent");
    plate.style.setProperty("--plate-badge-text", plainPlate ? "#ffffff" : theme.text);
    const regoInput = document.getElementById("bw-rego-input");
    if (regoInput) regoInput.placeholder = theme.placeholder || "E.G. ABC123";
    if (key !== "HEAVY") document.getElementById("bw-plate-state-abbr").textContent = key;
    document.getElementById("bw-plate-caption").textContent = theme.name;
  }

  function toggleRegoType(type) {
    const plate = document.getElementById('bw-plate');
    if (!plate) return;
    const isHeavy = (type === 'commercial');
    plate.classList.toggle('bw-plate-nostate', isHeavy);
    const stateSel = document.getElementById('bw-rego-state');
    applyPlateTheme(isHeavy ? 'HEAVY' : (stateSel ? stateSel.value : 'VIC'));
  }

  /* ---------- live YMM data ---------- */
  async function loadVehicleData() {
    try {
      const res = await fetch(withCode(YMM_DATA_URL), { cache: "no-store" });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "YMM data unavailable");
      makesList = data.makes || [];
      // "Treat this make as…" rules set in the portal. They sit on top of the built-in
      // list, so the team can fix a mismatch without this file being changed.
      portalAliases = {};
      Object.entries(data.aliases || {}).forEach(([k, v]) => {
        if (Array.isArray(v) && v.length) portalAliases[String(k).toUpperCase()] = v;
      });
      dataReady = true;
      populateMakes();
      if (data.status && data.status.regoAvailable === false) setRegoOff(data.status.message);
    } catch (err) {
      console.error("Vehicle data loading error:", err);
      showWidgetMessage("Vehicle list couldn't be loaded. Please refresh the page or try again shortly.", "error");
    }
  }

  // Vehicles are fetched one make at a time, so the full list is never sent in one go
  async function ensureMakeRows(make) {
    if (rowsByMake[make]) return rowsByMake[make];
    const res = await fetch(withCode(`${YMM_DATA_URL}?make=${encodeURIComponent(make)}`), { cache: "no-store" });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "YMM data unavailable");
    rowsByMake[make] = data.rows || [];
    return rowsByMake[make];
  }

  function rowsFor(make) { return rowsByMake[make] || []; }

  // Rego search switched off in the portal (planned or unplanned outage)
  function setRegoOff(message) {
    regoOff = true;
    const btn = document.getElementById("bw-rego-btn");
    const input = document.getElementById("bw-rego-input");
    if (btn) { btn.disabled = true; btn.innerText = "Unavailable"; }
    if (input) { input.disabled = true; input.placeholder = "UNAVAILABLE"; }
    const tab = document.querySelectorAll(".bw-tab-link")[0];
    if (tab && tab.classList.contains("active")) showWidgetMessage(escHtml(message || "Registration search is temporarily unavailable. Please search by Make, Model and Year."), "warning");
    regoOffMessage = message || "";
  }

  function getSelectedCsvVehicleType() { return VEHICLE_TYPE; }
  function onVehicleTypeChange() { populateMakes(); }

  /* ---------- dropdown controls ---------- */
  function handleDropdownKeyDown(e, type) {
    const items = document.getElementById(`dd-list-${type}`).querySelectorAll(".bw-dd-item");
    if (!items.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      highlightedIndices[type] = Math.min(highlightedIndices[type] + 1, items.length - 1);
      updateItemHighlight(type, items);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      highlightedIndices[type] = Math.max(highlightedIndices[type] - 1, 0);
      updateItemHighlight(type, items);
    } else if (e.key === "Enter") {
      e.preventDefault();
      let idx = highlightedIndices[type];
      if (idx < 0 || idx >= items.length) idx = 0;
      if (items[idx]) items[idx].click();
    } else if (e.key === "Escape") {
      closeAllDropdowns();
    }
  }

  function updateItemHighlight(type, items) {
    items.forEach((item, idx) => {
      if (idx === highlightedIndices[type]) { item.classList.add("highlighted"); item.scrollIntoView({ block: "nearest" }); }
      else item.classList.remove("highlighted");
    });
  }

  function toggleDropdown(type) {
    const wrapper = document.getElementById(`dd-wrapper-${type}`);
    const isOpen = wrapper.classList.contains("open");
    closeAllDropdowns();
    if (!isOpen) {
      wrapper.classList.add("open");
      const searchInput = document.getElementById(`dd-search-${type}`);
      searchInput.value = "";
      filterDropdownOptions(type, "");
      setTimeout(() => searchInput.focus(), 50);
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll(".bw-dd-wrapper").forEach(w => w.classList.remove("open"));
  }

  function renderCustomList(type, items) {
    const listEl = document.getElementById(`dd-list-${type}`);
    listEl.innerHTML = "";
    highlightedIndices[type] = -1;
    if (!items.length) { listEl.innerHTML = '<li class="bw-dd-empty">No results found</li>'; return; }
    items.forEach((val) => {
      const li = document.createElement("li");
      li.className = `bw-dd-item ${selectedValues[type] === val ? 'selected' : ''}`;
      li.textContent = val;
      li.onclick = (e) => {
        e.stopPropagation();
        // Picking a Make by hand starts a fresh, free search; picking a model or year
        // after a rego result still belongs to that rego search.
        if (type === "make") {
          regoKicker = ""; searchKind = "manual"; searchRef = null;
          pendingNotes = []; pendingLabel = ""; pendingFitNote = "";
        }
        selectOption(type, val);
      };
      listEl.appendChild(li);
    });
  }

  function filterDropdownOptions(type, query) {
    const q = query.toLowerCase().trim();
    renderCustomList(type, optionsData[type].filter(item => String(item).toLowerCase().includes(q)));
  }

  function selectOption(type, value) {
    selectedValues[type] = value;
    document.getElementById(`dd-label-${type}`).textContent = value;
    closeAllDropdowns();
    if (type === 'make') return onMakeSelect(value);
    if (type === 'model') onModelSelect(value);
    else if (type === 'year') onYearSelect(value);
  }

  /* ---------- cascading dropdowns ---------- */
  function populateMakes() {
    selectedValues = { make: "", model: "", year: "" };
    document.getElementById("dd-label-make").textContent = "Select Make...";
    document.getElementById("dd-label-model").textContent = "Select Model...";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    document.getElementById("dd-btn-model").disabled = true;
    document.getElementById("dd-btn-year").disabled = true;
    if (!dataReady) return;
    optionsData.make = [...makesList];
    renderCustomList("make", optionsData.make);
    document.getElementById("dd-btn-make").disabled = false;
  }

  async function onMakeSelect(make) {
    hideWidgetMessage();
    selectedValues.model = ""; selectedValues.year = "";
    document.getElementById("dd-label-model").textContent = "Select Model...";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    document.getElementById("dd-btn-year").disabled = true;
    document.getElementById("dd-btn-model").disabled = true;
    try {
      const rows = await ensureMakeRows(make);
      optionsData.model = [...new Set(rows.map(r => r.model))].sort();
      renderCustomList("model", optionsData.model);
      document.getElementById("dd-btn-model").disabled = false;
    } catch (err) {
      console.error("Model list error:", err);
      showWidgetMessage("Couldn't load the models for that make. Please try again shortly.", "error");
    }
  }

  function onModelSelect(model) {
    hideWidgetMessage();
    selectedValues.year = "";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    const rows = rowsFor(selectedValues.make).filter(r => r.model === model);
    optionsData.year = sortYears([...new Set(rows.map(r => r.year).filter(Boolean))]);
    renderCustomList("year", optionsData.year);
    document.getElementById("dd-btn-year").disabled = false;
    if (optionsData.year.length === 1) selectOption('year', optionsData.year[0]);
  }

  // Customer notes/warnings for the selected vehicle
  // Make, Model and Year are all filled (picked or pre-filled) -> show the batteries straight away
  function onYearSelect(year) {
    if (selectedValues.make && selectedValues.model && year) submitYMMSearchInterim();
  }

  /* ---------- submit & redirect ---------- */
  function submitYMMSearchInterim() {
    const { make, model, year } = selectedValues;
    if (!make || !model) { showWidgetMessage("Please select a Make and Model.", "warning"); return; }
    if (!year && optionsData.year.length > 1) { showWidgetMessage("Please select the Year of your vehicle.", "warning"); return; }
    const rows = rowsFor(make).filter(r => r.model === model && (!year || r.year === year));
    goToResults(rows, `${make} ${model}${year ? " (" + year + ")" : ""}`);
  }

  // Show the results on this page (and put them in the address so the link can be shared / Back works)
  // A quiet line under the vehicle name, only when several variants share one battery
  function showFitNote(text) {
    let el = document.getElementById("bwr-fitnote");
    if (!el) {
      const title = document.getElementById("bwr-vehicle");
      if (!title || !title.parentNode) return;
      el = document.createElement("div");
      el.id = "bwr-fitnote";
      el.className = "bwr-fitnote";
      title.parentNode.insertBefore(el, title.nextSibling);
    }
    el.textContent = text || "";
    el.style.display = text ? "block" : "none";
  }

  function goToResults(rows, vehicleLabel) {
    // When several variants were folded together, the heading is the customer's own car
    if (pendingLabel) { vehicleLabel = pendingLabel; pendingLabel = ""; }
    const codes = [...new Set(rows.flatMap(r => String(r.fitmentCode || "").split(",").map(c => c.trim()).filter(Boolean)))];
    // Warnings from every variant we folded together, so collapsing options never loses one
    const noteRows = rows.map(r => r.notes).concat(pendingNotes);
    pendingNotes = [];
    const notes = [...new Set(noteRows.flatMap(n => String(n || "").split(";").map(x => x.trim()).filter(Boolean)))];
    if (!codes.length) {
      showWidgetMessage("We don't have a battery match for this vehicle yet. Please contact us and we'll help you find the right one.", "info");
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set("fc", codes.join(","));
    url.searchParams.set("v", vehicleLabel);
    if (notes.length) url.searchParams.set("n", notes.join("; ")); else url.searchParams.delete("n");
    history.pushState({ bwResults: true }, "", url);

    // Remember the vehicle, not the battery – the codes are looked up again next time
    const { make, model, year } = selectedValues;
    if (make && model) {
      // A plate only belongs to this car if the rego search was a few minutes ago at most
      const fromRego = lastPlate && (Date.now() - lastPlate.at) < 10 * 60 * 1000 ? lastPlate : null;
      const existing = readGarage().find(c => normKey(c.make) === normKey(make) && normKey(c.model) === normKey(model) && (c.year || "") === (year || ""));
      saveToGarage({
        make, model, year: year || "",                       // the guide's year range
        built: (fromRego && fromRego.built) || (existing && existing.built) || "",   // the car's actual year
        plate: (fromRego && fromRego.rego) || (existing && existing.plate) || "",
        state: (fromRego && fromRego.state) || (existing && existing.state) || "",
      });
    }
    lastPlate = null;
    reportEvent("results", codes.join(","));

    renderResults(codes, vehicleLabel, notes);
  }

  function showResultsFromUrl() {
    const p = new URLSearchParams(window.location.search);
    const fc = (p.get("fc") || "").split(",").map(c => c.trim()).filter(Boolean);
    if (!fc.length) { document.getElementById("bwr-panel").style.display = "none"; return; }
    renderResults(fc, p.get("v") || "", (p.get("n") || "").split(";").map(n => n.trim()).filter(Boolean), false);
  }
  window.addEventListener("popstate", showResultsFromUrl);

  /* ---------- My garage (saved in this browser only) ---------- */
  // Vehicles the customer has looked up before, kept in localStorage so they can come
  // straight back to their car without paying for another rego lookup. The Make/Model/Year
  // is what's saved – the fitment codes are read fresh from the guide every time, so a
  // change in the portal reaches a saved car automatically.
  const GARAGE_KEY = "be_garage_v1";
  const GARAGE_MAX = 6;
  let lastPlate = null;             // { rego, state } while a rego result is being turned into results

  function readGarage() {
    try {
      const list = JSON.parse(localStorage.getItem(GARAGE_KEY) || "[]");
      return Array.isArray(list) ? list.filter(c => c && c.make && c.model) : [];
    } catch (e) { return []; }      // private browsing, or storage full/blocked
  }

  function writeGarage(list) {
    try { localStorage.setItem(GARAGE_KEY, JSON.stringify(list.slice(0, GARAGE_MAX))); } catch (e) { /* nothing we can do */ }
    renderGarage();
  }

  const garageKeyOf = c => normKey(c.make) + "|" + normKey(c.model) + "|" + normKey(c.year || "");
  // "2025 Great Wall Tank 300 Petrol" – the car's own year, never the guide's year range
  const garageName = c => [c.built, c.make, c.model].filter(Boolean).join(" ");

  function saveToGarage(car) {
    const list = readGarage().filter(c => garageKeyOf(c) !== garageKeyOf(car));
    // Keep the plate we already had for this car if this visit didn't come from a rego search
    writeGarage([{ ...car, at: Date.now() }, ...list]);
  }

  function removeFromGarage(key) {
    writeGarage(readGarage().filter(c => garageKeyOf(c) !== key));
    hideWidgetMessage();
  }

  function renderGarage() {
    let wrap = document.getElementById("bw-garage");
    const banner = document.getElementById("bw-status-banner");
    if (!wrap) {
      if (!banner || !banner.parentNode) return;
      wrap = document.createElement("div");
      wrap.id = "bw-garage";
      wrap.className = "bw-garage";
      banner.parentNode.insertBefore(wrap, banner.nextSibling);
    }
    const list = readGarage();
    if (!list.length) { wrap.style.display = "none"; wrap.innerHTML = ""; return; }

    wrap.style.display = "block";
    wrap.innerHTML = `
      <div class="bw-garage-head">
        <span class="bw-garage-title">My garage</span>
        <button type="button" class="bw-garage-clear" onclick="bwGarageClear()">Clear all</button>
      </div>
      <div class="bw-garage-row">
        ${list.map(c => {
          const key = garageKeyOf(c);
          return `<div class="bw-gcard">
            <button type="button" class="bw-gcard-main" onclick="bwGarageUse('${escAttr(key)}')"
                    title="Show batteries for this vehicle">
              <span class="bw-gcard-name">${escHtml(garageName(c))}</span>
              ${c.plate
                ? `<span class="bw-gcard-plate">${escHtml(c.plate)}${c.state ? " · " + escHtml(c.state) : ""}</span>`
                : `<span class="bw-gcard-sub">${escHtml(c.year || "Saved vehicle")}</span>`}
            </button>
            <button type="button" class="bw-gcard-x" aria-label="Remove this vehicle"
                    onclick="bwGarageRemove('${escAttr(key)}')">&times;</button>
          </div>`;
        }).join("")}
      </div>
      <div class="bw-garage-note">Saved on this device only. Remove a car and search again if anything looks wrong.</div>`;
  }

  // Bring a saved car back. The guide is re-read, so the codes are always current.
  async function useGarageCar(key) {
    const car = readGarage().find(c => garageKeyOf(c) === key);
    if (!car) return;
    hideWidgetMessage();
    if (!dataReady) { showWidgetMessage("Still loading vehicle data – please try again in a moment.", "info"); return; }

    // The make may have been renamed or retired in the guide since this was saved
    const make = makesList.find(m => normKey(m) === normKey(car.make));
    if (!make) return garageStale(car, key);
    await ensureMakeRows(make);
    const rows = rowsFor(make).filter(r => normKey(r.model) === normKey(car.model) && (!car.year || r.year === car.year));
    if (!rows.length) return garageStale(car, key);

    searchKind = "garage";                 // a repeat visit, and it cost us nothing
    searchRef = null;
    regoKicker = car.plate
      ? `Saved vehicle ${car.plate}${car.state ? " (" + car.state + ")" : ""} · ${garageName(car)} · Batteries to suit`
      : `Saved vehicle · ${garageName(car)} · Batteries to suit`;
    await prefillVehicleTab(make, [rows[0].model], rows[0].model, car.year || rows[0].year);
  }

  // The guide no longer has this vehicle – don't quietly show the wrong battery
  function garageStale(car, key) {
    const label = escHtml(garageName(car));
    showWidgetMessage(
      `Our battery guide has been updated for your <strong>${label}</strong>, so we've stopped using the saved details. ` +
      `<button type="button" class="bw-inline-link" onclick="bwGarageRemove('${escAttr(key)}')">Remove it</button> and ` +
      (car.plate ? `search <strong>${escHtml(car.plate)}</strong> again` : `pick it from the <strong>Vehicle</strong> list`) +
      ` for the current battery.`, "warning");
  }

  // Called from the markup above
  window.bwGarageUse = useGarageCar;
  window.bwGarageRemove = removeFromGarage;
  window.bwGarageClear = function () {
    if (!confirm("Remove every saved vehicle from this device?")) return;
    writeGarage([]);
    hideWidgetMessage();
  };

  function clearResults() {
    document.getElementById("bwr-panel").style.display = "none";
    document.getElementById("bwr-help").style.display = "none";
    const url = new URL(window.location.href);
    ["fc", "v", "n"].forEach(k => url.searchParams.delete(k));
    history.pushState({}, "", url);
  }

  /**
   * Bring the results into view WITHOUT scrolling past the widget itself – the customer
   * should still see My garage and the Make/Model/Year we filled in for them, because
   * that's how they check we got the right car. So we scroll to the top of the whole
   * widget, and only fall back to the results panel if the widget is too tall to fit.
   */
  function scrollToWidget(panel) {
    const box = panel.closest(".battery-widget-container") || panel;
    const gap = 16;                                    // a little breathing room above
    // A sticky header would otherwise sit over the top of the widget
    const stuck = [...document.querySelectorAll("header, .header, .site-header, .shopify-section-header, [role='banner']")]
      .filter(el => {
        const s = getComputedStyle(el);
        return (s.position === "fixed" || s.position === "sticky") && el.getBoundingClientRect().height < 200;
      })
      .reduce((h, el) => Math.max(h, el.getBoundingClientRect().height), 0);

    const room = window.innerHeight - stuck - gap;
    const boxTop = box.getBoundingClientRect().top;
    // What has to be on screen: everything from the top of the widget down to the
    // "Batteries to suit" heading – the garage, the tabs, and the Make/Model/Year.
    const head = panel.querySelector(".bwr-head") || panel;
    const needed = head.getBoundingClientRect().bottom - boxTop;

    // Only skip ahead to the results when all of that can't fit on the screen at once
    const target = needed > room ? panel : box;
    const top = window.scrollY + target.getBoundingClientRect().top - stuck - gap;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  /* ---------- results ---------- */
  const money = cents => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format((cents || 0) / 100);
  const sizedImg = (src, w) => src ? (src.startsWith("//") ? "https:" + src : src) + (src.includes("?") ? "&" : "?") + "width=" + w : "";
  let resultsRequest = 0;
  let productSpecs = {};               // handle -> { length, width, height, totalHeight, weight }
  let foundProducts = [];              // what the current search returned, before sorting
  let haveLocationData = false;        // did this search get any per-shop stock back at all?
  let sortMode = "recommended";
  let regoKicker = "";                         // "Found from rego ..." line for the next results

  async function renderResults(codes, vehicleLabel, notes, scroll = true) {
    const req = ++resultsRequest;
    const panel = document.getElementById("bwr-panel");
    const grid = document.getElementById("bwr-grid");
    const status = document.getElementById("bwr-status");
    const warnEl = document.getElementById("bwr-warn");

    hideWidgetMessage();
    panel.style.display = "block";
    document.getElementById("bwr-vehicle").textContent = vehicleLabel || "Your vehicle";
    document.getElementById("bwr-kicker").textContent = regoKicker || "Batteries to suit";
    showFitNote(pendingFitNote);
    pendingFitNote = "";
    regoKicker = "";
    if (notes.length) {
      document.getElementById("bwr-warn-list").innerHTML = notes.map(n => `<li>${escHtml(n)}</li>`).join("");
      warnEl.style.display = "flex";
    } else warnEl.style.display = "none";
    status.innerHTML = "Finding batteries for your vehicle…";
    productSpecs = {};
    document.getElementById("bwr-help-btn").href = CONTACT_URL;
    document.getElementById("bwr-help").style.display = "none";   // only shown once the search has finished
    grid.innerHTML = '<div class="bwr-skeleton"></div><div class="bwr-skeleton"></div><div class="bwr-skeleton"></div>';
    if (scroll) scrollToWidget(panel);

    try {
      const products = USE_THEME_FEED
        ? await productsFromTheme(codes)
        : await productsFromWorker(codes);
      if (req !== resultsRequest) return;                 // a newer search has started

      if (!products.length) {
        grid.innerHTML = "";
        showHelpBanner();
        status.innerHTML = 'We don\'t have a battery listed for this vehicle right now. Please <a href="/pages/contact">contact us</a> and we\'ll help you find the right one.';
        return;
      }
      // Shopify only lists a shop when it actually holds the battery, so "missing" means
      // "none here". If NO battery came back with any shop at all, the shop lookup isn't
      // working on this store and we show the plain in-stock line instead of false crosses.
      haveLocationData = products.some(p => (p.variants || []).some(v => (v.locations || []).length));
      foundProducts = products;
      status.innerHTML = statusBar(products.length);
      drawProducts();
      showHelpBanner();
    } catch (err) {
      if (req !== resultsRequest) return;
      console.error("Results error:", err);
      grid.innerHTML = "";
      showHelpBanner();
      status.innerHTML = 'Sorry, we couldn\'t load batteries right now. Please try again or <a href="/pages/contact">contact us</a>.';
    }
  }

  function showHelpBanner() { document.getElementById("bwr-help").style.display = "flex"; }

  // Straight from the theme – one request per fitment code, metafields included
  async function productsFromTheme(codes) {
    const seen = {};
    const feeds = await Promise.all(codes.map(c =>
      fetch(FEED_URL(c), { cache: "no-store" })
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    ));
    for (const feed of feeds) {
      const list = (feed && feed.products) || [];
      list.forEach((p, i) => {
        // Feeds come back best-selling first, so position = how popular it is
        p.rank = seen[p.handle] ? Math.min(seen[p.handle].rank, i) : i;
      });
      for (const p of list) {
        if (seen[p.handle]) { seen[p.handle].rank = Math.min(seen[p.handle].rank, p.rank); continue; }
        seen[p.handle] = p;
        const spec = {
          length: p.length_mm || "", width: p.width_mm || "", height: p.height_mm || "",
          totalHeight: p.total_height_mm || "", weight: p.weight_kg || "",
        };
        if (Object.values(spec).some(Boolean)) productSpecs[p.handle] = spec;
      }
    }
    return Object.values(seen);
  }

  // Older route: the Worker says which handles match, then Shopify gives the details
  async function productsFromWorker(codes) {
    const res = await fetch(withCode(`${PRODUCTS_URL}?fc=${encodeURIComponent(codes.join(","))}`), { cache: "no-store" });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "products_unavailable");
    productSpecs = data.specs || {};
    return (await Promise.all(data.handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}.js`, { cache: "no-store" }).then(r => r.ok ? r.json() : null).catch(() => null)
    ))).filter(Boolean);
  }

  const brandKey = s => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const BRAND_KEYS = BRAND_ORDER.map(brandKey);

  // Where this battery's brand sits in the preference list (lower = shown first)
  function brandRank(p) {
    const vendor = brandKey(p.vendor);
    let i = BRAND_KEYS.indexOf(vendor);
    if (i >= 0) return i;
    const title = brandKey(p.title);                 // fallback: brand named in the title
    i = BRAND_KEYS.findIndex(k => k.length >= 4 && title.includes(k));
    return i >= 0 ? i : BRAND_KEYS.length;
  }

  function sortProducts(list) {
    const out = [...list];
    const inStockFirst = (a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0);
    if (sortMode === "price-asc")  return out.sort((a, b) => inStockFirst(a, b) || a.price - b.price);
    if (sortMode === "price-desc") return out.sort((a, b) => inStockFirst(a, b) || b.price - a.price);
    if (sortMode === "popular")    return out.sort((a, b) => inStockFirst(a, b) || (a.rank || 0) - (b.rank || 0));
    // Recommended: in stock, then our brand order, then cheapest of that brand
    return out.sort((a, b) => inStockFirst(a, b) || brandRank(a) - brandRank(b) || a.price - b.price);
  }

  function changeSort(value) {
    sortMode = value;
    try { localStorage.setItem("bwSort", value); } catch (e) {}
    drawProducts();
  }

  function drawProducts() {
    const grid = document.getElementById("bwr-grid");
    const products = sortProducts(foundProducts);
    grid.innerHTML = products.map(cardHtml).join("");
    products.forEach(wireCard);
  }

  function statusBar(count) {
    const opts = [["recommended", "Recommended"], ["price-asc", "Price: low to high"],
                  ["price-desc", "Price: high to low"], ["popular", "Most bought"]];
    return `<span>${count} battery option${count === 1 ? "" : "s"} found</span>
      <span class="bwr-sort"><label for="bwr-sort-select">Sort by</label>
        <select id="bwr-sort-select" onchange="changeSort(this.value)">
          ${opts.map(([v, t]) => `<option value="${v}"${sortMode === v ? " selected" : ""}>${t}</option>`).join("")}
        </select></span>`;
  }

  function firstAvailable(p) { return p.variants.find(v => v.available) || p.variants[0]; }

  function cardHtml(p) {
    const v = firstAvailable(p);
    const img = sizedImg(p.featured_image || (v.featured_image && v.featured_image.src), 400);
    return `
      <div class="bwr-card" id="bwr-card-${p.id}">
        <a class="bwr-img" href="/products/${escHtml(p.handle)}">${img ? `<img src="${escHtml(img)}" alt="${escHtml(p.title)}" loading="lazy">` : ""}</a>
        <div class="bwr-vendor">${escHtml(p.vendor || "")}</div>
        <a class="bwr-name" href="/products/${escHtml(p.handle)}">${escHtml(p.title)}</a>
        <div class="bwr-money"><span class="bwr-price" data-price>${money(v.price)}</span><span class="bwr-compare" data-compare>${v.compare_at_price > v.price ? money(v.compare_at_price) : ""}</span></div>
        ${stockHtml(v)}
        ${specLine(p.handle)}
        ${p.variants.length > 1 ? `<select class="bwr-select" data-variant>${p.variants.map(x => `<option value="${x.id}" ${x.id === v.id ? "selected" : ""} ${x.available ? "" : "disabled"}>${escHtml(x.title)}${x.available ? "" : " – sold out"}</option>`).join("")}</select>` : ""}
        <div class="bwr-buy">
          <input class="bwr-qty" type="number" min="1" value="1" aria-label="Quantity" data-qty>
          <button type="button" class="bwr-add" data-add ${v.available ? "" : "disabled"}>${v.available ? "Add to cart" : "Sold out"}</button>
        </div>
        <div class="bwr-msg" data-msg></div>
      </div>`;
  }

  // L 260 x W 173 x H 190 (Total height: 205) | 17.5kg – only the parts that are filled in
  function specLine(handle) {
    const s = productSpecs[handle] || {};
    const bits = [];
    const dims = [s.length && `L ${s.length}`, s.width && `W ${s.width}`, s.height && `H ${s.height}`].filter(Boolean);
    if (dims.length) bits.push(dims.join(" x ") + (s.totalHeight ? ` (Total height: ${s.totalHeight})` : ""));
    if (s.weight) bits.push(`${s.weight}kg`);
    return `<div class="bwr-spec">${bits.length ? escHtml(bits.join(" | ")) : ""}</div>`;
  }

  // Per-shop stock with a tick or cross. Falls back to plain In stock / Out of stock
  // when Shopify gives us no location breakdown for this battery.
  function stockHtml(variant) {
    const locs = Array.isArray(variant.locations) ? variant.locations : [];
    if (!haveLocationData) {
      return `<div class="bwr-stock ${variant.available ? "bwr-in" : "bwr-out"}" data-stock>${variant.available ? "In stock" : "Out of stock"}</div>`;
    }

    const matched = new Set();
    const rows = STOCK_LOCATIONS.map(cfg => {
      if (cfg.useOverall) return { label: cfg.label, title: cfg.label, available: !!variant.available };
      const hit = locs.find(l => normKey(l.name).includes(normKey(cfg.match)));
      if (hit) matched.add(hit.name);
      // Not listed by Shopify = this shop doesn't hold it
      return { label: cfg.label, title: hit ? hit.name : cfg.label, available: !!(hit && hit.available) };
    });

    // Any other shop that came back and isn't in the list above
    for (const l of locs) {
      if (matched.has(l.name)) continue;
      if (STOCK_LOCATIONS.some(cfg => normKey(l.name).includes(normKey(cfg.match)))) continue;
      rows.push({ label: l.name, title: l.name, available: !!l.available });
    }

    return `<div class="bwr-stock-list" data-stock>${rows.map(r => {
      const qty = Number(r.quantity);
      const count = Number.isFinite(qty) && qty > 0 ? `: ${qty}` : "";
      return `<div class="bwr-loc ${r.available ? "bwr-loc-yes" : "bwr-loc-no"}" title="${escHtml(r.title)}">
        <span class="bwr-loc-mark" aria-hidden="true">${r.available ? "&#10003;" : "&#10007;"}</span>
        <span class="bwr-loc-name">${escHtml(r.label)}${count}</span></div>`;
    }).join("")}</div>`;
  }

  function wireCard(p) {
    const card = document.getElementById(`bwr-card-${p.id}`);
    const sel = card.querySelector("[data-variant]");
    const btn = card.querySelector("[data-add]");
    const msg = card.querySelector("[data-msg]");
    let variant = firstAvailable(p);

    if (sel) sel.addEventListener("change", () => {
      variant = p.variants.find(x => String(x.id) === sel.value) || variant;
      card.querySelector("[data-price]").textContent = money(variant.price);
      card.querySelector("[data-compare]").textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : "";
      const stock = card.querySelector("[data-stock]");
      if (stock) stock.outerHTML = stockHtml(variant);
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? "Add to cart" : "Sold out";
    });

    btn.addEventListener("click", async () => {
      const qty = Math.max(1, parseInt(card.querySelector("[data-qty]").value, 10) || 1);
      btn.disabled = true; btn.textContent = "Adding…"; msg.textContent = "";
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Couldn't add to cart");
        btn.textContent = "Added ✓";
        reportEvent("add_to_cart", p.fitment_code || "", qty);
        showToast(`${qty} × ${p.title} added to cart`);
        refreshCartCount();
        setTimeout(() => { btn.textContent = "Add to cart"; btn.disabled = false; }, 1500);
      } catch (err) {
        msg.textContent = err.message;
        btn.textContent = "Add to cart";
        btn.disabled = false;
      }
    });
  }

  function showToast(text) {
    document.getElementById("bwr-toast-msg").textContent = text;
    document.getElementById("bwr-toast").style.display = "flex";
    clearTimeout(showToast.t);
    showToast.t = setTimeout(() => { document.getElementById("bwr-toast").style.display = "none"; }, 6000);
  }

  // Update the theme's cart counter (covers the common theme selectors)
  async function refreshCartCount() {
    try {
      const cart = await (await fetch("/cart.js", { cache: "no-store" })).json();
      document.querySelectorAll(".cart-count-bubble span[aria-hidden='true'], [data-cart-count], .cart-count, .cart-item-count, #CartCount")
        .forEach(el => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
    } catch (e) { /* counter is cosmetic */ }
  }

  /* ---------- rego search ---------- */
  function resolveMakes(apiMake) {
    const raw = String(apiMake || "").trim();
    if (!raw) return [];

    const lookup = list => {
      const wanted = list.map(normKey).filter(Boolean);
      return makesList.filter(m => wanted.includes(normKey(m)));
    };

    // 1. The portal's own rules first, then the built-in list, then the make as given
    const upper = raw.toUpperCase();
    let hit = lookup(portalAliases[upper] || MAKE_ALIASES[upper] || [raw]);
    if (hit.length) return hit;

    // 2. Same again with the padding words stripped ("ISUZU UTE" -> "ISUZU")
    const cleaned = upper.replace(MAKE_NOISE, " ").replace(/\s+/g, " ").trim();
    if (cleaned && cleaned !== upper) {
      hit = lookup(portalAliases[cleaned] || MAKE_ALIASES[cleaned] || [cleaned]);
      if (hit.length) return hit;
    }

    // 3. Last resort so a missing alias never dead-ends: one guide make is clearly
    //    the same badge ("VOLKSWAGEN GOLF R" -> Volkswagen). Four characters
    //    minimum on both sides, so "AC" can't swallow "ACURA".
    const key = normKey(cleaned || upper);
    if (key.length >= 4) {
      hit = makesList.filter(m => {
        const k = normKey(m);
        return k.length >= 4 && (k === key || k.startsWith(key) || key.startsWith(k));
      });
      if (hit.length) return hit;
    }
    return [];
  }

  // Body shapes. Two vocabularies on purpose:
  //
  // API_BODY – what the rego database calls them, including the manufacturers' own names
  //   for a wagon. "C-CLASS TOURING" is a C Class wagon.
  // ROW_BODY – only the words OUR guide uses as a body descriptor. Deliberately narrower,
  //   because "Camry 2.4i Touring" and "Volkswagen Kombi" are model names, not shapes,
  //   and reading those as "wagon" would push the right row down.
  const API_BODY = {
    wagon: ["wagon", "touring", "estate", "avant", "variant", "tourer", "sportwagon"],
    sedan: ["sedan", "saloon"], coupe: ["coupe"],
    convertible: ["convertible", "cabriolet", "cabrio", "roadster"],
    hatch: ["hatch", "hatchback"], van: ["van"],
    ute: ["ute", "utility", "pickup"],
  };
  // "avant" is safe here – in our guide it only ever appears on genuine Audi wagons.
  // "touring" is not: it's a Camry and a Lotus trim level as well as a BMW wagon.
  const ROW_BODY = {
    wagon: ["wagon", "avant"], sedan: ["sedan", "saloon"], coupe: ["coupe"],
    convertible: ["convertible", "cabriolet", "roadster"],
    hatch: ["hatch", "hatchback"], van: ["van"],
    ute: ["ute", "utility", "pickup"],
  };
  const flip = map => {
    const out = {};
    for (const [body, list] of Object.entries(map)) for (const w of list) out[w] = body;
    return out;
  };
  const API_BODY_OF = flip(API_BODY), ROW_BODY_OF = flip(ROW_BODY);

  // Which body shape a piece of text names, if any
  const bodyOf = (text, table) => {
    if (/cab chassis/i.test(text)) return "ute";
    for (const w of words(text)) if (table[w]) return table[w];
    return "";
  };

  // Returns [{ make, model, year, notes }] – the rows that best fit the rego result
  function findModelMatches(makes, v) {
    const allRows = makes.flatMap(rowsFor);
    // What shape is this car? The model name wins over bodyType, because the rego
    // database is more specific there ("C-CLASS TOURING" vs a bodyType of "WAGON").
    const wantBody = bodyOf(v.model, API_BODY_OF) || bodyOf(v.bodyType, API_BODY_OF);

    // 1. Narrow by MODEL first – the strongest signal. Whole-word matching, so a model
    //    called "3" doesn't match "CX-7 Petrol 2.3i".
    const makeWords = new Set(makes.flatMap(m => words(m)));
    const apiWords = words(v.model).filter(w => !makeWords.has(w));

    const narrow = wanted => allRows.filter(r => {
      const rw = words(r.model);
      if (wanted.length && wanted.every(w => rw.includes(w))) return true;
      return rw.length && rw[0].length >= 4 && wanted.includes(rw[0]);   // e.g. "RANGE ROVER SPORT" -> "Sport Petrol 5.0i"
    });

    let hits = narrow(apiWords);
    // Nothing matched and the model name carries a body word? Our guide may just call that
    // shape something else – "C-CLASS TOURING" is "C Class … wagon" here. Try again without
    // it; the shape is still used for scoring below. This is only a fallback, so an
    // "A4 AVANT" still matches the Avant rows on the first pass.
    if (!hits.length) {
      const withoutBody = apiWords.filter(w => !API_BODY_OF[w]);
      if (withoutBody.length && withoutBody.length < apiWords.length) hits = narrow(withoutBody);
    }
    // Nothing matched on whole words – fall back to a looser check rather than showing nothing
    if (!hits.length) {
      const apiModel = normKey(v.model);
      hits = allRows.filter(r => normKey(r.model).includes(apiModel) || apiModel.includes(normKey(r.model)));
    }
    if (!hits.length) return [];

    // 1b. The model name has to START with what we were given, once the make is
    //     stripped off the front: a Mazda "3" is "Mazda 3 2.0i", never "CX-3 Petrol 2.0i".
    if (apiWords.length) {
      const strong = hits.filter(r => {
        const rw = words(r.model);
        let i = 0;
        while (i < rw.length && makeWords.has(rw[i])) i++;      // skip "Mazda" in "Mazda 3"
        return apiWords.every((w, n) => rw[i + n] === w);
      });
      if (strong.length) hits = strong;
    }

    // 2. Then narrow by YEAR within that model – build month first, then the whole year.
    //    If the vehicle is newer than every row for that model (a 2024 Triton against rows
    //    ending 2023), keep the model rows rather than throwing them all away.
    const exact = hits.filter(r => yearMatches(r.year, v.year, v.compliance, true));
    const loose = hits.filter(r => yearMatches(r.year, v.year, v.compliance, false));
    if (exact.length) hits = exact; else if (loose.length) hits = loose;

    const byModel = {};
    hits.forEach(r => (byModel[r.model] = byModel[r.model] || []).push(r));

    const scored = Object.entries(byModel).map(([model, rs]) => {
      const t = model.toLowerCase();
      let s = 0;
      const saysDiesel = /diesel|\d\.\d+d/.test(t), saysPetrol = /petrol/.test(t);
      const wrongFuel = (v.fuel === "Diesel" && saysPetrol) || (v.fuel === "Petrol" && saysDiesel);
      if (v.fuel === "Diesel") s += saysDiesel ? 2 : (saysPetrol ? -5 : 0);
      if (v.fuel === "Petrol") s += saysPetrol ? 2 : (saysDiesel ? -5 : 0);
      if (v.engineLitres && !wrongFuel) {          // engine size never rescues the wrong fuel
        const engines = t.match(/\d\.\d(?=[a-z]|\b)/g);
        if (engines) s += engines.includes(v.engineLitres) ? 3 : -2;
      }
      // Grade / trim from the rego result, e.g. GLS, VX, Sportivo
      const gradeWords = words(v.grade).filter(w => w.length >= 2);
      if (gradeWords.length) {
        const modelWords = words(model);
        if (gradeWords.every(w => modelWords.includes(w))) s += 3;
      }
      const modelWords = words(model);

      // Series code (VE, GDJ150R, PX) – in the series column or in the model name itself
      if (v.series) {
        const vs = normKey(v.series);
        const inColumn = rs.some(r => { const cs = normKey(r.series); return cs.length >= 2 && (cs.includes(vs) || vs.includes(cs)); });
        // The part of a series code that carries the digits is the telling part:
        // "ZRE182R" should beat "ZRE172R", not tie with it on the shared "ZRE".
        let inName = 0;
        words(v.series).filter(w => w.length >= 2).forEach(w => {
          if (modelWords.includes(w)) inName += /\d/.test(w) ? 3 : 1;
        });
        if (inName) s += Math.max(3, inName); else if (inColumn) s += 1;
      }

      // Body shape. Our guide writes it at the end of the model name ("… wagon"), the
      // rego database puts it in bodyType and sometimes in the model ("C-CLASS TOURING").
      // A row that names a body only fits a vehicle of that body; a row that names none
      // fits them all, so it is never penalised.
      const rowBody = bodyOf(t, ROW_BODY_OF);
      if (rowBody && wantBody) {
        if (rowBody === wantBody) s += rowBody === "ute" ? 2 : 3;
        else s += rowBody === "ute" || wantBody === "ute" ? -4 : -3;
      }

      // Transmission, where the guide distinguishes them
      if (v.transmission) {
        const auto = /auto/i.test(v.transmission), manual = /manual/i.test(v.transmission);
        if (/auto trans|automatic/.test(t)) s += auto ? 2 : -3;
        if (/\bmanual\b/.test(t)) s += manual ? 2 : -3;
      }

      // Fleet-only entries shouldn't win a tie against the normal model
      if (/police|taxi|fleet/.test(t) && !/police|taxi|fleet/i.test(v.grade || "")) s -= 2;

      // An auxiliary/second battery is an add-on, not the battery most customers came for
      if (/auxiliary|aux\.|back-up|backup|second battery/.test(t)) s -= 3;
      return { make: rs[0].make, model, year: rs[0].year, rows: rs, notes: rs.map(r => r.notes).filter(Boolean).join("; "), s };
    });

    const best = Math.max(...scored.map(x => x.s));
    return scored.filter(x => x.s === best);
  }

  async function submitRegoSearchInterim() {
    hideWidgetMessage();
    const rego = document.getElementById("bw-rego-input").value.trim().toUpperCase();
    const stateSelect = document.getElementById("bw-rego-state");
    const state = stateSelect ? stateSelect.value : "VIC";
    const btn = document.getElementById("bw-rego-btn");

    if (regoOff) { showWidgetMessage(escHtml(regoOffMessage || "Registration search is temporarily unavailable. Please search by Make, Model and Year below."), "warning"); return; }
    if (!rego) { showWidgetMessage("Please enter a registration plate.", "warning"); return; }
    if (!dataReady) { showWidgetMessage("Still loading vehicle data – please try again in a moment.", "info"); return; }

    btn.innerText = "Searching...";
    btn.disabled = true;

    try {
      const response = await fetch(CLOUDFLARE_WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rego, state, category: "car", code: getAccessCode() }),
        cache: "no-store"
      });
      const result = await response.json();

      if (!result.success) {
        if (result.error === "rego_off") {
          setRegoOff(result.message);
          showWidgetMessage(escHtml(result.message || "Registration search is temporarily unavailable. Please search by Make, Model and Year below."), "warning");
        } else if (result.error === "not_a_car") {
          showWidgetMessage(`That registration is for a <strong>${escHtml(result.vehicleType)}</strong>. We can only look up cars at the moment – please use the <strong>Vehicle</strong> tab.`, "warning");
        } else if (result.error === "rate_limited") {
          showCodeLink();
          showWidgetMessage(`You've reached the daily limit for rego searches. Please try again ${escHtml(result.retryAfter || "tomorrow")}, or search by <strong>Vehicle</strong> below. Trade customers can enter their code underneath.`, "warning");
        } else if (result.error === "not_found" || result.error === "invalid_rego") {
          showWidgetMessage(`We couldn't find <strong>${escHtml(rego)}</strong> in ${escHtml(state)}. Please check the plate and state, or search by <strong>Vehicle</strong>.`, "warning");
        } else {
          showWidgetMessage("Unable to query the registration database right now. Please search using the <strong>Vehicle</strong> tab.", "error");
        }
        return;
      }

      const v = result.vehicle;
      const label = `${escHtml(v.year)} ${escHtml(v.make)} ${escHtml(v.model)}`;
      const makes = resolveMakes(v.make);
      // So the plate and the build year get saved alongside the vehicle once the batteries show
      lastPlate = { rego, state, at: Date.now(), built: String(v.year || "") };
      searchKind = "rego";
      searchRef = result.logRef || null;

      if (!makes.length) {
        // The rego database uses a badge our guide files under another name. Don't
        // dead-end – hand them the Vehicle tab with every make ready to pick.
        reportMatch(result.logRef, v.likelyCar === false ? "not_a_car" : "no_make");
        if (v.likelyCar === false) { showWidgetMessage(notInGuideMessage(v, label), "warning"); return; }
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        openVehicleTabBlank();
        showWidgetMessage(`We found your <strong>${label}</strong>, but couldn't match that make automatically. Please pick it from the <strong>Make</strong> list below – if it isn't there, <a href="${CONTACT_URL}">contact us</a> and we'll find the right battery for you.`, "info");
        return;
      }

      await Promise.all(makes.map(ensureMakeRows));
      const matches = findModelMatches(makes, v);

      const codesOf = m => (m.rows || []).map(r => r.fitmentCode).filter(Boolean).join(", ");
      // Do all of these options come down to the same battery?
      const codeKey = m => [...new Set((m.rows || []).flatMap(r =>
        String(r.fitmentCode || "").split(",").map(c => c.trim().toUpperCase()).filter(Boolean)))].sort().join("|");
      const sameBattery = ms => {
        const first = codeKey(ms[0]);
        return !!first && ms.every(m => codeKey(m) === first);
      };

      if (matches.length === 1) {
        // Exact vehicle found: fill Make / Model / Year and show the batteries (warnings appear in their own box)
        reportMatch(result.logRef, "matched", matches[0].make + " " + matches[0].model, codesOf(matches[0]), 1);
        regoKicker = `Found from rego ${rego} (${state}) · ${v.year} ${v.make} ${v.model} · Batteries to suit`;
        await prefillVehicleTab(matches[0].make, [matches[0].model], matches[0].model, matches[0].year);
      } else if (matches.length > 1 && sameBattery(matches)) {
        // Several model names, one battery. Asking which variant they have would be a
        // question with only one answer, so show the batteries and leave the Model list
        // open in case they want to change it.
        pendingNotes = matches.flatMap(m => (m.rows || []).map(r => r.notes)).filter(Boolean);
        reportMatch(result.logRef, "matched", matches.map(m => m.model).join(" / "), codesOf(matches[0]), matches.length);
        // Name the customer's own car, not one of the variants we didn't actually pick
        // between – otherwise a D300 owner is told we matched the 2.0.
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        pendingLabel = [v.year, v.make, v.model].filter(Boolean).join(" ") + (v.grade ? ` ${v.grade}` : "");
        pendingFitNote = sameBatteryNote(matches);
        await prefillVehicleTab(matches[0].make, matches.map(m => m.model), matches[0].model, matches[0].year);
      } else if (matches.length > 1) {
        reportMatch(result.logRef, "choose", matches.map(m => m.model).join(" | "), codesOf(matches[0]), matches.length);
        await prefillVehicleTab(matches[0].make, matches.map(m => m.model));
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        showWidgetMessage(`We found your <strong>${label}</strong>! Please choose your exact engine/variant from the <strong>Model</strong> list – your batteries will show straight away.`, "info");
      } else if (v.likelyCar === false) {
        // Registered as a truck and nothing in the car guide fits it
        reportMatch(result.logRef, "not_a_car");
        showWidgetMessage(notInGuideMessage(v, label), "warning");
      } else {
        // The make is in our guide but this model isn't – the portal flags it so a row can be added
        reportMatch(result.logRef, "no_model", "", "", 0);
        await prefillVehicleTab(makes[0], []);
        showWidgetMessage(`We found your <strong>${label}</strong>, but couldn't match the exact model. Please choose it from the <strong>Model</strong> list.`, "info");
      }
    } catch (err) {
      console.error("Rego Lookup Error:", err);
      showWidgetMessage("Unable to query the registration database right now. Please search using the <strong>Vehicle</strong> tab.", "error");
    } finally {
      btn.innerText = "Find Battery";
      btn.disabled = false;
    }
  }

  // Tell the Worker what we did with the result. The matching happens here in the browser,
  // so this is the only way the portal can flag the cars our guide is missing.
  // Best effort – a customer never sees it and it never holds anything up.
  function reportMatch(ref, state, model, code, count) {
    if (!ref) return;
    post("/match", { ref, state, model: model || "", code: code || "", count: count || 0 });
  }

  // How the current results were found, so the portal can compare a paid rego lookup
  // against a free Make/Model/Year search or a saved vehicle
  let searchKind = "manual";
  let searchRef = null;
  let searchId = null;          // one id per search, so three batteries added is still one sale

  const newSearchId = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

  // Batteries shown / battery added to cart. Counts only – no customer or cart details.
  function reportEvent(step, code, qty) {
    if (step === "results") searchId = newSearchId();
    post("/event", { kind: searchKind, step, ref: searchRef || "", sid: searchId || "", code: code || "", qty: qty || 0 });
  }

  function post(path, body) {
    try {
      fetch(CLOUDFLARE_WORKER_URL.replace(/\/+$/, "") + path, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body), keepalive: true, cache: "no-store"
      }).catch(() => {});
    } catch (e) { /* never blocks the customer */ }
  }

  function notInGuideMessage(v, label) {
    return (v && v.likelyCar === false)
      ? `We found your <strong>${label}</strong>, but it's registered as a commercial vehicle and isn't in our car guide. Truck searches are coming soon – please contact us and we'll find the right battery for you.`
      : `We found your <strong>${label}</strong>, but it isn't in our battery guide yet. Please contact us and we'll help you find the right battery.`;
  }

  // Switch to the Vehicle tab with nothing chosen yet, just the full make list
  function openVehicleTabBlank() {
    const vehicleTabBtn = document.querySelectorAll('.bw-tab-link')[1];
    if (vehicleTabBtn) openSearchTab({ currentTarget: vehicleTabBtn }, 'tab-vehicle');
    populateMakes();
  }

  // Switch to the Vehicle tab with make (and optionally model/year) filled in
  async function prefillVehicleTab(make, modelList, model, year) {
    const vehicleTabBtn = document.querySelectorAll('.bw-tab-link')[1];
    if (vehicleTabBtn) openSearchTab({ currentTarget: vehicleTabBtn }, 'tab-vehicle');
    populateMakes();
    await selectOption('make', make);
    if (modelList.length > 1) {
      optionsData.model = [...modelList].sort();
      renderCustomList("model", optionsData.model);
    }
    if (model) {
      selectOption('model', model);                                   // auto-picks the year if there's only one
      if (year && selectedValues.year !== year) selectOption('year', year);   // -> runs the search
    }
  }

  /* ---------- tabs & messages ---------- */
  function openSearchTab(evt, tabName) {
    hideWidgetMessage();
    closeAllDropdowns();
    const content = document.getElementsByClassName("bw-tab-content");
    for (let i = 0; i < content.length; i++) { content[i].classList.remove("active-content"); content[i].style.display = "none"; }
    const links = document.getElementsByClassName("bw-tab-link");
    for (let i = 0; i < links.length; i++) links[i].classList.remove("active");
    const activeTab = document.getElementById(tabName);
    activeTab.style.display = "block";
    setTimeout(() => { activeTab.classList.add("active-content"); }, 10);
    evt.currentTarget.classList.add("active");
  }

  function showWidgetMessage(msg, type = "warning") {
    const banner = document.getElementById("bw-status-banner");
    if (!banner) return;
    banner.className = `bw-status-box bw-status-${type}`;
    banner.innerHTML = `<span>${msg}</span><button class="bw-status-close" onclick="hideWidgetMessage()">&times;</button>`;
    banner.style.display = "flex";
  }

  function hideWidgetMessage() {
    const banner = document.getElementById("bw-status-banner");
    if (banner) banner.style.display = "none";
  }